import { types } from "../types/types";

const initialState = {
    flujocajamensual: {},
    flujocajaPasado: {},
    flujoCajaTablaSemanal: {},
    financiamientoCard: {},
    updateNeeded: {},
    cashFlowCategories: {},
    cashFlowAreas: {},
    currency: 'CLP',
    updateHoldingCashFlowData: false,
    updateHoldingCashFlowNeeded: { value: false, reload: true },
    updateHoldingCashFlowStructure: { value: false },
};

export const holdingCashFlowReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.getUpdateHoldingCashFlowNeeded:
            return {
                ...state,
                updateHoldingCashFlowNeeded: { ...action.payload },
            };
        default:
            return state;
    }
}